import React, {useContext, useEffect, useState} from "react";
import {Typography} from "@material-ui/core";
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import findByString from "../../../../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import {
    DimensionsField, FlexDirection, AlignmentBlock,
    PickImage, SelectField, TypographyStyle, ColorPicker,
    MultiValueField, HoverColorPicker
} from "./InputFields";
import CollapsedFields from "./CollapsedFields";
import CustomCss from "./InputFields/CustomCss";
import DefaultType from "../../../../../../../../Utils/Form/FormDynamic/Fields/DefaultType/DefaultType";
import ScriptType from "../../../../../../../../Utils/Form/FormDynamic/Fields/ScriptType";

const Styles = () => {
    const {
        selectedComponent: {component, path, isListObject},
        screenValues,
        onChangeDefaultFields,
        preparedToSaveLists, setImageContent,
        currentCustomResolution
    } = useContext(ScreenDesignerContextNew);
    const {_isLocked} = component || {};
    const resolutionPath = currentCustomResolution === 'desktop' ? '' : '.' + currentCustomResolution;
    const [currentDirection, setCurrentDirection] = useState('column');
    const currentValues = isListObject ? preparedToSaveLists : screenValues;
    const currentPath = isListObject ? path.split('.').slice(1).join('.') : path;
    const rowDirection = findByString(currentValues, `${currentPath}.styles.0.flexDirection`);

    useEffect(() => {
        setCurrentDirection(rowDirection || 'column')
    }, [rowDirection]);

    const schemaStyles = {
        button: [
            {type: "string", name: 'className', label: "Css Class"},
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {
                type: "select", name: "background", label: "Color", menu: [
                    {label: 'Primary', value: 'primary'},
                    {label: 'Secondary', value: 'secondary'},
                    {label: 'Default', value: 'default'}
                ]
            },
            {
                type: 'select', name: "variant", label: 'Variant', menu: [
                    {label: 'Contained', value: 'contained'},
                    {label: 'Outlined', value: 'outlined'},
                    {label: 'Text', value: 'text'}
                ]
            },
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: 'typography', label: "Typography"},
            {
                type: "multiValue",
                name: "border",
                label: "Border",
                placeholders: ['Top', 'Right', 'Bottom', 'Left']
            },
            {type: 'dimensions', name: 'borderRadius', label: "Border Radius"},
            {type: "colorPicker", name: "borderColor", label: "Border Color"},
            {
                type: 'collapsed', name: 'activeStyles', label: 'Active styles', fields: [
                    {type: "dimensions", name: 'width', label: "Width"},
                    {type: "dimensions", name: "height", label: "Height"},
                    {
                        type: "select", name: "background", label: "Color", menu: [
                            {label: 'Primary', value: 'primary'},
                            {label: 'Secondary', value: 'secondary'},
                            {label: 'Default', value: 'default'}
                        ]
                    },
                    {
                        type: 'select', name: "variant", label: 'Variant', menu: [
                            {label: 'Contained', value: 'contained'},
                            {label: 'Outlined', value: 'outlined'},
                            {label: 'Text', value: 'text'}
                        ]
                    },
                    {
                        type: "multiValue",
                        name: "padding",
                        label: "Padding",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {
                        type: "multiValue",
                        name: "margin",
                        label: "Margin",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: 'typography', label: "Typography"},
                    {
                        type: "multiValue",
                        name: "border",
                        label: "Border",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: 'dimensions', name: 'borderRadius', label: "Border Radius"},
                    {type: "colorPicker", name: "borderColor", label: "Border Color"},
                ]
            }
        ],
        label: [
            {type: "string", name: 'className', label: "Css Class"},
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: 'typography', label: "Typography"},
            {
                type: 'select', name: "whiteSpace", label: 'White Space', menu: [
                    {label: 'No Wrap', value: 'noWrap'},
                    {label: 'Break Spaces', value: 'break-spaces'}
                ]
            },
        ],
        panel: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {
                type: "direction", name: "flexDirection", label: "Direction"
            },
            {
                type: "verticalAlign",
                name: currentDirection === 'column' ? "justifyContent" : "alignItems",
                label: 'Vertical Align'
            },
            {
                type: "horizontalAlign",
                name: currentDirection === 'column' ? "alignItems" : "justifyContent",
                label: 'Horizontal Align'
            },
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {
                type: "multiValue",
                name: "boxShadow",
                label: "Shadow",
                placeholders: ['Vertical', 'Horizont', 'Blur', 'Spread']
            },
            {type: "colorPicker", name: "shadowColor", label: "Shadow Color"},
            {type: "multiValue", name: "border", label: "Border", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {
                type: 'select', name: "overflow", label: 'Overflow Type', menu: [
                    {label: 'Auto', value: 'auto'},
                    {label: 'Scroll', value: 'scroll'},
                    {label: 'Visible', value: 'visible'},
                ]
            },
            {type: "colorPicker", name: "borderColor", label: "Border Color"},
            {type: "colorPicker", name: "background", label: "Background"},
            {type: 'pickImage', name: 'backgroundImage', label: 'Background Image'}
        ],
        card: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {
                type: "direction", name: "flexDirection", label: "Direction"
            },
            {
                type: "verticalAlign",
                name: currentDirection === 'column' ? "justifyContent" : "alignItems",
                label: 'Vertical Align'
            },
            {
                type: "horizontalAlign",
                name: currentDirection === 'column' ? "alignItems" : "justifyContent",
                label: 'Horizontal Align'
            },
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {
                type: "multiValue",
                name: "boxShadow",
                label: "Shadow",
                placeholders: ['Vertical', 'Horizont', 'Blur', 'Spread']
            },
            {type: "colorPicker", name: "shadowColor", label: "Shadow Color"},
            {
                type: "multiValue",
                name: "border",
                label: "Border",
                placeholders: ['Top', 'Right', 'Bottom', 'Left']
            },
            {type: 'dimensions', name: 'borderRadius', label: "Border Radius"},
            {type: "colorPicker", name: "borderColor", label: "Border Color"},
            {type: "colorPicker", name: "background", label: "Background"},
        ],
        block: [
            {type: "string", name: 'className', label: "Css Class"},
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {type: "dimensions", name: 'maxWidth', label: "Max Width"},
            {
                type: "direction", name: "flexDirection", label: "Direction"
            },
            {
                type: "verticalAlign",
                name: currentDirection === 'column' ? "justifyContent" : "alignItems",
                label: 'Vertical Align'
            },
            {
                type: "horizontalAlign",
                name: currentDirection === 'column' ? "alignItems" : "justifyContent",
                label: 'Horizontal Align'
            },
            {type: "dimensions", name: 'gap', label: "Gap"},
            {type: "string", name: 'flexGrow', label: "Flex Grow"},
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {
                type: "multiValue",
                name: "boxShadow",
                label: "Shadow",
                placeholders: ['Vertical', 'Horizont', 'Blur', 'Spread']
            },
            {type: "colorPicker", name: "shadowColor", label: "Shadow Color"},
            {
                type: "multiValue",
                name: "border",
                label: "Border",
                placeholders: ['Top', 'Right', 'Bottom', 'Left']
            },
            {
                type: 'select', name: "borderStyle", label: 'Border Style', menu: [
                    {label: 'Solid', value: 'solid'},
                    {label: 'Dashed', value: 'dashed'},
                    {label: 'Dotted', value: 'dotted'},
                    {label: 'Inset', value: 'inset'},
                ]
            },
            {type: 'dimensions', name: 'borderRadius', label: "Border Radius"},
            {type: "colorPicker", name: "borderColor", label: "Border Color"},
            {type: "colorPicker", name: "background", label: "Background"},
            {type: 'pickImage', name: 'backgroundImage', label: 'Background Image'},
            {
                type: 'select', name: "display", label: 'Display Type', menu: [
                    {label: 'Flex Box', value: 'flex'},
                    {label: 'Block', value: 'block'}
                ]
            },
            {
                type: 'select', name: "overflow", label: 'Overflow Type', menu: [
                    {label: 'Auto', value: 'auto'},
                    {label: 'Scroll', value: 'scroll'},
                    {label: 'Visible', value: 'visible'},
                ]
            },
            {
                type: 'collapsed', name: 'hoverStyles', label: 'Hover Styles', fields: [
                    {
                        type: "multiValue",
                        name: "boxShadow",
                        label: "Shadow",
                        placeholders: ['Vertical', 'Horizont', 'Blur', 'Spread']
                    },
                    {type: "colorPicker", name: "shadowColor", label: "Shadow Color"},
                    {type: "colorPicker", name: "background", label: "Background"},
                    {type: "colorPicker", name: "color", label: "Text Color"},
                    {
                        type: "multiValue",
                        name: "border",
                        label: "Border",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {
                        type: 'select', name: "borderStyle", label: 'Border Style', menu: [
                            {label: 'Solid', value: 'solid'},
                            {label: 'Dashed', value: 'dashed'},
                            {label: 'Dotted', value: 'dotted'},
                            {label: 'Inset', value: 'inset'},
                        ]
                    },
                    {type: 'dimensions', name: 'borderRadius', label: "Border Radius"},
                    {type: "colorPicker", name: "borderColor", label: "Border Color"},

                    {type: "customCss", name: "customStyles", label: "Custom Styles"},
                ]
            },
            {
                type: 'collapsed', name: 'activeStyles', label: 'Active styles', fields: [
                    {type: "dimensions", name: 'width', label: "Width"},
                    {type: "dimensions", name: "height", label: "Height"},
                    {
                        type: "select", name: "background", label: "Color", menu: [
                            {label: 'Primary', value: 'primary'},
                            {label: 'Secondary', value: 'secondary'},
                            {label: 'Default', value: 'default'}
                        ]
                    },
                    {
                        type: 'select', name: "variant", label: 'Variant', menu: [
                            {label: 'Contained', value: 'contained'},
                            {label: 'Outlined', value: 'outlined'},
                            {label: 'Text', value: 'text'}
                        ]
                    },
                    {
                        type: "multiValue",
                        name: "padding",
                        label: "Padding",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {
                        type: "multiValue",
                        name: "margin",
                        label: "Margin",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: 'typography', label: "Typography"},
                    {
                        type: "multiValue",
                        name: "border",
                        label: "Border",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: 'dimensions', name: 'borderRadius', label: "Border Radius"},
                    {type: "colorPicker", name: "borderColor", label: "Border Color"},
                ]
            }

        ],
        list: [
            {
                type: 'group', label: 'General Styles', fields: [
                    {type: "dimensions", name: 'width', label: "Width"},
                    {type: "dimensions", name: "height", label: "Height"},
                    {type: "dimensions", name: "minHeight", label: "Min Height"},
                    {type: "dimensions", name: "maxHeight", label: "Max Height"},
                    {
                        type: "multiValue",
                        name: "padding",
                        label: "Padding",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {
                        type: "multiValue",
                        name: "margin",
                        label: "Margin",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {
                        type: "multiValue",
                        name: "boxShadow",
                        label: "Shadow",
                        placeholders: ['Vertical', 'Horizont', 'Blur', 'Spread']
                    },
                    {type: "colorPicker", name: "shadowColor", label: "Shadow Color"},
                    {
                        type: "multiValue",
                        name: "border",
                        label: "Border",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: "colorPicker", name: "borderColor", label: "Border Color"},
                    {
                        type: 'select', name: "overflow", label: 'Overflow Type', menu: [
                            {label: 'Auto', value: 'auto'},
                            {label: 'Scroll', value: 'scroll'},
                            {label: 'Visible', value: 'visible'},
                        ]
                    },
                ]
            },
            {
                type: 'group', label: "Row Styles", fields: [
                    {type: "dimensions", name: "height", label: "Height"},
                    {type: 'typography', label: "Typography"},
                    {
                        type: "multiValue",
                        name: "border",
                        label: "Border",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: "colorPicker", name: "borderColor", label: "Border Color"},
                    {
                        type: 'collapsed', name: 'hoverStyles', label: 'Hover styles', fields: [
                            {type: "dimensions", name: "height", label: "Height"},
                            {type: 'typography', label: "Typography"},
                            {
                                type: "multiValue",
                                name: "border",
                                label: "Border",
                                placeholders: ['Top', 'Right', 'Bottom', 'Left']
                            },
                            {type: "colorPicker", name: "borderColor", label: "Border Color"},
                            {type: "colorPicker", name: "background", label: "Background"},
                            {
                                type: "multiValue",
                                name: "boxShadow",
                                label: "Shadow",
                                placeholders: ['Vertical', 'Horizont', 'Blur', 'Spread']
                            },
                            {type: "colorPicker", name: "shadowColor", label: "Shadow Color"},
                        ]
                    }
                ]
            },
            {
                type: 'group', label: "Toolbar", fields: [
                    {type: "dimensions", name: "height", label: "Height"},
                    {
                        type: "multiValue",
                        name: "padding",
                        label: "Padding",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: "colorPicker", name: "background", label: "Background"},
                ]
            },
            {
                type: 'group', label: "Head Row Styles", fields: [
                    {type: "dimensions", name: "height", label: "Height"},
                    {type: 'typography', label: "Typography"},
                    {
                        type: "multiValue",
                        name: "border",
                        label: "Border",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: "colorPicker", name: "borderColor", label: "Border Color"},
                ]
            },
        ],
        line: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "colorPicker", name: "color", label: "Color"},
            {
                type: 'select', name: "variant", label: 'Variant', menu: [
                    {label: 'Full Width', value: 'fullWidth'},
                    {label: 'Inset', value: 'inset'},
                    {label: 'Middle', value: 'middle'}
                ]
            },
        ],
        image: [
            {type: "string", name: 'className', label: "Css Class"},
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {
                type: "multiValue",
                name: "boxShadow",
                label: "Shadow",
                placeholders: ['Vertical', 'Horizont', 'Blur', 'Spread']
            },
            {type: "colorPicker", name: "shadowColor", label: "Shadow Color"},
            {
                type: "multiValue",
                name: "border",
                label: "Border",
                placeholders: ['Top', 'Right', 'Bottom', 'Left']
            },
            {type: 'dimensions', name: 'borderRadius', label: "Border Radius"},
            {type: "colorPicker", name: "borderColor", label: "Border Color"},
        ],
        chat: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
        ],
        text: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "customCss", name: "customStyles", label: "Custom Styles"},
        ],
        band: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
        ],
        surveyHeader: [
            {type: 'typography', label: "Typography"},
        ],
        surveyQuestion: [
            {type: 'typography', label: "Typography"},
        ],
        surveyScoring: [
            {type: 'typography', label: "Typography"},
        ],
        field: [
            {
                type: 'group', label: "Field Styles", fields: [
                    {type: "dimensions", name: 'width', label: "Width"},
                    {type: "dimensions", name: 'height', label: "Height"},
                    {
                        type: "multiValue",
                        name: "margin",
                        label: "Margin",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {
                        type: "select", name: "fullWidth", label: "Full Width", menu: [
                            {label: 'True', value: true},
                            {label: 'False', value: false},
                        ]
                    },
                    {
                        type: "select", name: "hideLabel", label: "Hide Label", menu: [
                            {label: 'True', value: true},
                            {label: 'False', value: false},
                        ]
                    },
                    {
                        type: 'select', name: "presentation", label: 'Presentation', menu: [
                            {label: 'Standard', value: 'outlined'},
                            {label: 'Inline', value: 'standard'},
                            {label: 'Inline with label', value: 'inlineWithLabel'},
                            {label: 'Stacked with label', value: 'stackLabel'},
                            {label: 'Checkbox', value: 'checkbox'},
                            {label: 'Switch', value: 'switch'},
                            {label: 'Radio', value: 'radio'},
                        ]
                    },
                    {
                        type: "select", name: "withoutStyles", label: "Without Styles", menu: [
                            {label: 'True', value: true},
                            {label: 'False', value: false},
                        ]
                    },
                    {
                        type: "select", name: "textAlign", label: "Text Align", menu: [
                            {label: 'Left', value: 'left'},
                            {label: 'Center', value: 'center'},
                            {label: 'Right', value: 'right'}
                        ]
                    },
                    {
                        type: "select", name: "hideNumberArrows", label: "Hide № Arrows", menu: [
                            {label: 'True', value: true},
                            {label: 'False', value: false},
                        ]
                    },
                    {
                        type: 'conditionalStyles', name: "conditionalStyles", label: "Custom Styles"
                    }

                ]
            },
            {
                type: 'group', label: "Label Styles", fields: [
                    {type: "dimensions", name: 'width', label: "Width"},
                    {
                        type: "multiValue",
                        name: "margin",
                        label: "Margin",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: 'typography', label: "Typography"},
                ]
            }
        ],
        survey: [
            {
                type: 'group', label: "Header", fields: [
                    {
                        type: "multiValue",
                        name: "padding",
                        label: "Padding",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: 'typography', label: "Typography"}
                ]
            },
            {
                type: 'group', label: "Body", fields: [
                    {
                        type: "multiValue",
                        name: "padding",
                        label: "Padding",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: 'typography', label: "Typography"}
                ]
            },
            {
                type: 'group', label: "Footer", fields: [
                    {
                        type: "multiValue",
                        name: "padding",
                        label: "Padding",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: 'typography', label: "Typography"}
                ]
            },
        ],
        tabs: [
            {
                type: 'group', label: 'General Styles', fields: [
                    {type: "string", name: 'className', label: "Css Class"},
                    {type: "dimensions", name: 'width', label: "Width"},
                    {type: "dimensions", name: "height", label: "Height"},
                    {
                        type: "multiValue",
                        name: "margin",
                        label: "Margin",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {
                        type: "select", name: "indicatorColor", label: "Indicator Color", menu: [
                            {label: 'Primary', value: 'primary'},
                            {label: 'Secondary', value: 'secondary'}
                        ]
                    },
                    {
                        type: "select", name: "orientation", label: "Orientation", menu: [
                            {label: 'Vertical', value: 'vertical'},
                            {label: 'Horizontal', value: 'horizontal'}
                        ]
                    },
                    {
                        type: "select", name: "alignTabText", label: "Tab Text Align", menu: [
                            {label: 'Left', value: 'baseline'},
                            {label: 'Center', value: 'center'},
                            {label: 'Right', value: 'flex-end'},
                        ]
                    },
                    {type: "colorPicker", name: 'background', label: 'Background'},
                    {
                        type: "multiValue",
                        name: "boxShadow",
                        label: "Shadow",
                        placeholders: ['Vertical', 'Horizont', 'Blur', 'Spread']
                    },
                    {type: "colorPicker", name: "shadowColor", label: "Shadow Color"},
                ]
            },
            {
                type: 'group', label: 'Tab Styles', fields: [
                    {
                        type: "multiValue",
                        name: "margin",
                        label: "Margin",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: 'typography', label: "Typography"},
                    {
                        type: "multiValue",
                        name: "border",
                        label: "Border",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {
                        type: 'select', name: "borderStyle", label: 'Border Style', menu: [
                            {label: 'Solid', value: 'solid'},
                            {label: 'Dashed', value: 'dashed'},
                            {label: 'Dotted', value: 'dotted'},
                            {label: 'Inset', value: 'inset'},
                        ]
                    },
                    {type: 'dimensions', name: 'borderRadius', label: "Border Radius"},
                    {type: "colorPicker", name: "borderColor", label: "Border Color"},
                    {
                        type: 'collapsed', name: 'selectedTabStyles', label: "Selected Tab Styles", fields: [
                            {type: 'typography', label: "Typography"},
                            {
                                type: "multiValue",
                                name: "border",
                                label: "Border",
                                placeholders: ['Top', 'Right', 'Bottom', 'Left']
                            },
                            {
                                type: 'select', name: "borderStyle", label: 'Border Style', menu: [
                                    {label: 'Solid', value: 'solid'},
                                    {label: 'Dashed', value: 'dashed'},
                                    {label: 'Dotted', value: 'dotted'},
                                    {label: 'Inset', value: 'inset'},
                                ]
                            },
                            {type: 'dimensions', name: 'borderRadius', label: "Border Radius"},
                            {type: "colorPicker", name: "borderColor", label: "Border Color"},
                            {type: "colorPicker", name: "indicatorColor", label: "Indicator Color"},
                        ]
                    }
                ]
            }

        ],
        container: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {
                type: "verticalAlign",
                name: "alignItems",
                label: 'Vertical Align'
            },
            {
                type: "horizontalAlign",
                name: "justifyContent",
                label: 'Horizontal Align'
            },
            {
                type: "multiValue",
                name: "boxShadow",
                label: "Shadow",
                placeholders: ['Vertical', 'Horizont', 'Blur', 'Spread']
            },
            {type: "colorPicker", name: "shadowColor", label: "Shadow Color"},
            {
                type: "multiValue",
                name: "border",
                label: "Border",
                placeholders: ['Top', 'Right', 'Bottom', 'Left']
            },
            {type: "colorPicker", name: "borderColor", label: "Border Color"},
            {type: "colorPicker", name: "background", label: "Background"},
            {type: 'pickImage', name: 'backgroundImage', label: 'Background Image'},
        ],
        embeddedScreen: [
            {type: "string", name: 'className', label: "Css Class"},
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
        ],
        stepper: [
            {
                type: 'group', label: 'General Styles', fields: [
                    {type: "dimensions", name: 'width', label: "Width"},
                    {type: "dimensions", name: "height", label: "Height"},
                    {
                        type: "multiValue",
                        name: "padding",
                        label: "Padding",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {
                        type: "multiValue",
                        name: "margin",
                        label: "Margin",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: "colorPicker", name: "background", label: "Background"},
                    {
                        type: "multiValue",
                        name: "border",
                        label: "Border",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: 'dimensions', name: 'borderRadius', label: "Border Radius"},
                    {
                        type: "multiValue",
                        name: "boxShadow",
                        label: "Shadow",
                        placeholders: ['Vertical', 'Horizont', 'Blur', 'Spread']
                    },
                    {type: "colorPicker", name: "shadowColor", label: "Shadow Color"},
                ]
            },
            {
                type: 'group', label: 'Step Styles', fields: [
                    {type: 'typography', label: "Typography"},
                    {
                        type: "multiValue",
                        name: "border",
                        label: "Border",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {
                        type: 'select', name: "borderStyle", label: 'Border Style', menu: [
                            {label: 'Solid', value: 'solid'},
                            {label: 'Dashed', value: 'dashed'},
                            {label: 'Dotted', value: 'dotted'},
                            {label: 'Inset', value: 'inset'},
                        ]
                    },
                    {type: 'dimensions', name: 'borderRadius', label: "Border Radius"},
                    {type: "colorPicker", name: "borderColor", label: "Border Color"},
                    {
                        type: 'collapsed', name: 'selectedTabStyles', label: "Selected Step Styles", fields: [
                            {type: 'typography', label: "Typography"},
                            {
                                type: "multiValue",
                                name: "border",
                                label: "Border",
                                placeholders: ['Top', 'Right', 'Bottom', 'Left']
                            },
                            {
                                type: 'select', name: "borderStyle", label: 'Border Style', menu: [
                                    {label: 'Solid', value: 'solid'},
                                    {label: 'Dashed', value: 'dashed'},
                                    {label: 'Dotted', value: 'dotted'},
                                    {label: 'Inset', value: 'inset'},
                                ]
                            },
                            {type: 'dimensions', name: 'borderRadius', label: "Border Radius"},
                            {type: "colorPicker", name: "borderColor", label: "Border Color"},
                        ]
                    }
                ]
            },
            {
                type: 'group', label: 'Action button styles', fields: [
                    {type: "dimensions", name: 'width', label: "Width"},
                    {type: "dimensions", name: "height", label: "Height"},
                    {type: 'dimensions', name: 'borderRadius', label: "Border Radius"},
                ]
            }
        ],
        step: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
        ],
        fieldArray: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"}
        ],
        progress: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
        ],
        selectionCriteria: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
        ],
        feed: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
        ],
        feedPost: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
        ],
        forEach: [
            {type: "string", name: 'className', label: "Css Class"},
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {
                type: "horizontalAlign",
                name: "alignItems",
                label: 'Horizontal Align'
            },
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "colorPicker", name: "background", label: "Background"},
            {
                type: "multiValue",
                name: "border",
                label: "Border",
                placeholders: ['Top', 'Right', 'Bottom', 'Left']
            },
            {type: 'dimensions', name: 'borderRadius', label: "Border Radius"},
            {type: "colorPicker", name: "borderColor", label: "Border Color"},
        ],
        bottomMenu: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
        ],
        maps: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
        ],
        checkbox: [
            {
                label: "Label Placement", name: 'labelPlacement', type: 'select', menu: [
                    {label: 'Start', value: 'start'},
                    {label: 'End', value: 'end'},
                    {label: 'Top', value: 'top'},
                    {label: 'Bottom', value: 'bottom'},
                ]
            },
            {
                label: "Size", name: 'size', type: 'select', menu: [
                    {label: 'Medium', value: 'medium'},
                    {label: 'Small', value: 'small'}
                ]
            },
            {type: 'typography', label: "Typography"},
        ],
        switch: [
            {
                label: "Label Placement", name: 'labelPlacement', type: 'select', menu: [
                    {label: 'Start', value: 'start'},
                    {label: 'End', value: 'end'},
                    {label: 'Top', value: 'top'},
                    {label: 'Bottom', value: 'bottom'},
                ]
            },
            {
                label: "Size", name: 'size', type: 'select', menu: [
                    {label: 'Medium', value: 'medium'},
                    {label: 'Small', value: 'small'}
                ]
            },
        ],
        dropzone: [
            {type: "string", name: 'className', label: "Css Class"},
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
        ],
        icon: [
            {type: "typography", label: "Typography"},
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
        ],
        searchBar: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {
                label: "Variant", name: 'variant', type: 'select', menu: [
                    {label: 'Outlined', value: 'outlined'},
                    {label: 'Inline', value: 'standard'}
                ]
            },
            {
                label: "Size", name: 'size', type: 'select', menu: [
                    {label: 'Default', value: 'default'},
                    {label: 'Small', value: 'small'}
                ]
            },
            {
                label: "Icon Position", name: 'iconPosition', type: 'select', menu: [
                    {label: 'Start', value: 'start'},
                    {label: 'End', value: 'end'},
                ]
            },

        ],
        header: [
            {type: "string", name: 'className', label: "Css Class"},
            {type: "dimensions", name: "height", label: "Height"},
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {
                type: 'select', name: "position", label: 'Position', menu: [
                    {label: 'Static', value: 'static'},
                    {label: 'Absolute', value: 'absolute'},
                ]
            },
            {
                type: "direction", name: "flexDirection", label: "Direction"
            },
            {
                type: "verticalAlign",
                name: currentDirection === 'column' ? "justifyContent" : "alignItems",
                label: 'Vertical Align'
            },
            {
                type: "horizontalAlign",
                name: currentDirection === 'column' ? "alignItems" : "justifyContent",
                label: 'Horizontal Align'
            },
            {type: "colorPicker", name: "background", label: "Background"},
            {
                type: "multiValue",
                name: "boxShadow",
                label: "Shadow",
                placeholders: ['Vertical', 'Horizont', 'Blur', 'Spread']
            },
            {type: "colorPicker", name: "shadowColor", label: "Shadow Color"},
            {
                type: "multiValue",
                name: "border",
                label: "Border",
                placeholders: ['Top', 'Right', 'Bottom', 'Left']
            },
            {type: 'dimensions', name: 'borderRadius', label: "Border Radius"},
            {type: "colorPicker", name: "borderColor", label: "Border Color"},
            {
                type: 'collapsed', name: 'onScrollStyles', label: 'On Scroll', fields: [
                    {type: "dimensions", name: "height", label: "Height"},
                    {
                        type: "multiValue",
                        name: "padding",
                        label: "Padding",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: "colorPicker", name: "background", label: "Background"},
                    {type: "colorPicker", name: "shadowColor", label: "Shadow Color"},
                    {
                        type: "multiValue",
                        name: "border",
                        label: "Border",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: 'dimensions', name: 'borderRadius', label: "Border Radius"},
                    {type: "colorPicker", name: "borderColor", label: "Border Color"},
                ]
            }
        ],
        badge: [
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {
                label: "Color", name: 'color', type: 'select', menu: [
                    {label: 'Primary', value: 'primary'},
                    {label: 'Secondary', value: 'secondary'},
                    {label: 'Default', value: 'default'}
                ]
            },
            {
                label: "Variant", name: 'variant', type: 'select', menu: [
                    {label: 'String', value: 'string'},
                    {label: 'Dot', value: 'dot'}
                ]
            },
        ],
        rating: [
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "colorPicker", name: "color", label: "Color"},
            {
                label: "Size", name: 'size', type: 'select', menu: [
                    {label: 'Small', value: 'small'},
                    {label: 'Medium', value: 'medium'},
                    {label: 'Large', value: 'large'}
                ]
            },
        ],
        radioGroup: [
            {
                type: "select", name: "orientation", label: "Orientation", menu: [
                    {label: 'Vertical', value: 'vertical'},
                    {label: 'Horizontal', value: 'horizontal'}
                ]
            },
            {
                type: "select", name: "labelPlacement", label: "Label Place", menu: [
                    {label: 'Start', value: 'start'},
                    {label: 'End', value: 'end'},
                    {label: 'Top', value: 'top'},
                    {label: 'Bottom', value: 'bottom'},
                ]
            },
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {
                label: "Size", name: 'size', type: 'select', menu: [
                    {label: 'Medium', value: 'medium'},
                    {label: 'Small', value: 'small'}
                ]
            },
            {type: 'typography', label: "Typography"},
        ],
        menuItem: [
            {
                type: 'group', label: 'Menu Item Styles', fields: [
                    {
                        type: "multiValue",
                        name: "padding",
                        label: "Padding",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: 'typography', label: "Typography"},
                ]
            },
            {
                type: 'group', label: 'Menu Item Container Styles', fields: [
                    {
                        type: "multiValue",
                        name: "padding",
                        label: "Padding",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {
                        type: "multiValue",
                        name: "border",
                        label: "Border",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: "colorPicker", name: "borderColor", label: "Border Color"},
                ]
            }

        ],
        menu: [
            {type: "string", name: 'listClassName', label: "List Css Class"},
            {type: "string", name: 'className', label: "Item Css Class"},
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "colorPicker", name: "background", label: "Background"},
            {
                type: 'group', label: "Dropdown Item", groupIndex: 1, fields: [
                    {type: 'typography', label: "Typography"},
                    {type: 'hoverColorPicker', label: "Text Color", name: 'color'},
                    {type: "hoverColorPicker", name: "background", label: "Background"},
                ]
            }
        ],
        swiperItem: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {
                type: "verticalAlign",
                name: currentDirection === 'column' ? "justifyContent" : "alignItems",
                label: 'Vertical Align'
            },
            {
                type: "horizontalAlign",
                name: currentDirection === 'column' ? "alignItems" : "justifyContent",
                label: 'Horizontal Align'
            },
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "colorPicker", name: "background", label: "Background"},
            {type: 'pickImage', name: 'backgroundImage', label: 'Background Image'},
        ],
        swiper: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
        ],
        footer: [
            {type: "dimensions", name: "height", label: "Height"},
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "colorPicker", name: "background", label: "Background"},
        ],
        sidebar: [
            {type: "string", name: 'className', label: "Css Class"},
            {type: "colorPicker", name: "background", label: "Background"},
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
        ],
        frame: [
            {type: "string", name: 'className', label: "Css Class"},
            {type: "colorPicker", name: "background", label: "Background"},
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
        ],
        accordion: [
            {
                type: "group", label: "General Styles", fields: [
                    {type: "dimensions", name: 'width', label: "Width"},
                    {type: "dimensions", name: "height", label: "Height"},
                    {
                        type: "multiValue",
                        name: "padding",
                        label: "Padding",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {
                        type: "multiValue",
                        name: "margin",
                        label: "Margin",
                        placeholders: ['Top', 'Right', 'Bottom', 'Left']
                    },
                    {type: "colorPicker", name: "arrowColor", label: "Arrow Color"},
                ]
            },
            {
                type: "group", label: "Label Styles", fields: [
                    {type: "dimensions", name: "width", label: "Width"},
                ]
            }
        ],
        tab: [
            {type: "dimensions", name: "height", label: "Height"},
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: 'typography', label: "Typography"},
        ],
        options: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
        ],
        serverTime: [
            {type: "string", name: 'className', label: "Css Class"},
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: 'typography', label: "Typography"},
        ],
        camera: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
        ],
        pdfReader: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
        ],
        restrictions: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
        ],
        context: [
            {type: "string", name: 'listClassName', label: "List Css Class"},
            {type: "string", name: 'className', label: "Item Css Class"},
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "colorPicker", name: "background", label: "Background"},
            {
                type: 'group', label: "Dropdown Item", groupIndex: 1, fields: [
                    {type: 'typography', label: "Typography"},
                    {type: 'hoverColorPicker', label: "Text Color", name: 'color'},
                    {type: "hoverColorPicker", name: "background", label: "Background"},
                ]
            }
        ],
        table: [
            {type: "multiValue", name: "margin", label: "Margin", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "colorPicker", name: "borderColor", label: "Border Color"},
            {type: 'dimensions', name: 'borderRadius', label: "Border Radius"},
        ],
        tableTd: [
            {type: "colorPicker", name: "borderColor", label: "Border Color"},
            {type: "colorPicker", name: "background", label: "Background"},
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {
                type: "verticalAlign",
                name: "justifyContent",
                label: 'Vertical Align'
            },
            {
                type: "horizontalAlign",
                name: "alignItems",
                label: 'Horizontal Align'
            },
        ],
        tableTh: [
            {type: "dimensions", name: 'width', label: "Width"},
            {type: "dimensions", name: "height", label: "Height"},
            {type: "multiValue", name: "padding", label: "Padding", placeholders: ['Top', 'Right', 'Bottom', 'Left']},
            {type: "colorPicker", name: "borderColor", label: "Border Color"},
            {type: "colorPicker", name: "background", label: "Background"},
            {
                type: "verticalAlign",
                name: "justifyContent",
                label: 'Vertical Align'
            },
            {
                type: "horizontalAlign",
                name: "alignItems",
                label: 'Horizontal Align'
            },
        ]
    };

    //setValue should return (value, path) by default
    function setValues(value, path) {
        onChangeDefaultFields(value, path)
    }

    return (
        schemaStyles[component.type] ? (
            schemaStyles[component.type].map((field, index) => {
                let singlePathName = field.name ? `${currentPath}.styles.0${resolutionPath}.${field.name}` : `${currentPath}.styles.0${resolutionPath}`;
                let singlePathForRoot = field.name ? `styles.0${resolutionPath}.${field.name}` : `styles.0${resolutionPath}`;
                let singlePath = currentPath ? singlePathName : singlePathForRoot;
                const groupIndex = field.groupIndex ? field.groupIndex : index;
                return (
                    field.type === 'group' ? (
                        <fieldset style={{
                            padding: '4px 5px',
                            border: `1px solid #b0b0b0`,
                            margin: index === 1 ? '10px 0 0 0' : 0,

                        }} key={index}>
                            <legend>{field.label}</legend>
                            {field.fields.map((fld, styleIndex) => {
                                let pathName = fld.name ? `${currentPath}.styles.${groupIndex}${resolutionPath}.${fld.name}` : `${currentPath}.styles.${groupIndex}${resolutionPath}`;
                                let pathForRoot = fld.name ? `styles.${groupIndex}${resolutionPath}.${fld.name}` : `styles.${groupIndex}${resolutionPath}`;
                                let groupPath = currentPath ? pathName : pathForRoot;
                                if (fld.type === 'collapsed') {
                                    return (
                                        <CollapsedFields key={index} label={fld.label}>
                                            {fld.fields.map((collapsedField, collapsedFieldIndex) => {
                                                let pathName = collapsedField.name ? `${currentPath}.styles.${groupIndex}${resolutionPath}.${fld.name}.${collapsedField.name}` : `${currentPath}.styles.${groupIndex}${resolutionPath}.${fld.name}`;
                                                let pathForRoot = collapsedField.name ? `styles.${groupIndex}${resolutionPath}.${fld.name}.${collapsedField.name}` : `styles.${groupIndex}${resolutionPath}.${fld.name}`;
                                                let groupPath = currentPath ? pathName : pathForRoot;
                                                return (
                                                    <StylesFields
                                                        key={collapsedFieldIndex}
                                                        field={{...collapsedField, disabled: _isLocked}}
                                                        values={currentValues}
                                                        path={groupPath}
                                                        setValue={setValues}
                                                        setImageContent={setImageContent}
                                                    />
                                                )
                                            })}
                                        </CollapsedFields>
                                    )
                                }
                                return (
                                    <StylesFields
                                        key={styleIndex}
                                        field={{...fld, disabled: _isLocked}}
                                        values={currentValues}
                                        path={groupPath}
                                        setValue={setValues}
                                        setImageContent={setImageContent}
                                    />
                                )
                            })}

                        </fieldset>
                    ) : field.type === 'collapsed' ? (
                            <CollapsedFields key={index} label={field.label}>
                                {field.fields.map((collapsedField, collapsedFieldIndex) => {
                                    let pathName = collapsedField.name ? `${currentPath}.styles.0${resolutionPath}.${field.name}.${collapsedField.name}` : `${currentPath}.styles.0${resolutionPath}.${field.name}`;
                                    let pathForRoot = collapsedField.name ? `styles.0${resolutionPath}.${field.name}.${collapsedField.name}` : `styles.0${resolutionPath}.${field.name}`;
                                    let groupPath = currentPath ? pathName : pathForRoot;
                                    return (
                                        <StylesFields
                                            key={collapsedFieldIndex}
                                            field={{...collapsedField, disabled: _isLocked}}
                                            values={currentValues}
                                            path={groupPath}
                                            setValue={setValues}
                                            setImageContent={setImageContent}
                                        />
                                    )
                                })}
                            </CollapsedFields>
                        )
                        : (
                            <StylesFields
                                key={index}
                                field={{...field, disabled: _isLocked}}
                                values={currentValues}
                                path={singlePath}
                                setValue={setValues}
                                setImageContent={setImageContent}
                            />

                        )
                )
            })
        ) : (
            <Typography color={"textSecondary"}>
                Styles schema is not defined for this component
            </Typography>
        )
    )
};

export default Styles;

const StylesFields = ({field, values, path, setValue, setImageContent}) => {
    return (
        (() => {
            switch (field.type) {
                case 'dimensions':
                    return (
                        <DimensionsField
                            label={field.label}
                            disabled={field.disabled}
                            name={field.name}
                            values={values}
                            setValue={setValue}
                            path={path}
                        />
                    );
                case 'multiValue':
                    return (
                        <MultiValueField
                            label={field.label}
                            disabled={field.disabled}
                            placeholders={field.placeholders}
                            setValue={setValue}
                            path={path}
                            values={values}
                        />
                    );
                case 'select':
                    return (
                        <SelectField
                            label={field.label}
                            disabled={field.disabled}
                            menu={field.menu}
                            setValue={setValue}
                            path={path}
                            values={values}
                        />
                    );
                case 'colorPicker':
                    return (
                        <ColorPicker
                            label={field.label}
                            disabled={field.disabled}
                            setValue={setValue}
                            path={path}
                            values={values}
                        />
                    );
                case 'typography':
                    return (
                        <TypographyStyle
                            label={field.label}
                            disabled={field.disabled}
                            setValue={setValue}
                            path={path}
                            values={values}
                        />
                    );
                case 'verticalAlign':
                    return (
                        <AlignmentBlock
                            label={field.label}
                            disabled={field.disabled}
                            setValue={setValue}
                            path={path}
                            values={values}
                            type={'vertical'}
                        />
                    );
                case 'horizontalAlign':
                    return (
                        <AlignmentBlock
                            label={field.label}
                            setValue={setValue}
                            disabled={field.disabled}
                            path={path}
                            values={values}
                            type={'horizontal'}
                        />
                    );
                case 'direction':
                    return (
                        <FlexDirection
                            label={field.label}
                            disabled={field.disabled}
                            setValue={setValue}
                            path={path}
                            values={values}
                        />
                    );
                case 'pickImage':
                    return <PickImage
                        label={field.label}
                        disabled={field.disabled}
                        setValue={setValue}
                        path={path}
                        values={values}
                        setImageContent={setImageContent}
                    />;
                case 'hoverColorPicker':
                    return <HoverColorPicker
                        label={field.label}
                        disabled={field.disabled}
                        setValue={setValue}
                        path={path}
                        values={values}
                    />
                case 'customCss':
                    return <CustomCss
                        label={field.label}
                        disabled={field.disabled}
                        setValue={setValue}
                        path={path}
                        values={values}
                    />
                case 'conditionalStyles':
                    return <ScriptType
                        labelStyles={{width: 100}}
                        fieldStyles={{height: 43, width: 220, fullWidth: false}}
                        values={values}
                        field={{
                            disabled: field.disabled,
                            label: "Conditional Styles",
                            inputMode: 'popup',
                            path: `${path}`,
                            syntaxHighlight: "javascript"
                        }}
                        setValue={setValue}
                    />
                case 'string':
                    return <DefaultType
                        field={{type: "string", label: field.label, path, disabled: field.disabled}}
                        values={values}
                        setValue={setValue}
                        labelStyles={{width: 100}}
                        fieldStyles={{width: 220}}
                    />
                default:
                    return <div>WOOOOOPS</div>
            }
        })()
    )
};